module.exports = "<app-layout>\n  <div class=\"container\">\n    <div class=\"inner\">\n      <h1 class=\"mat-title\">Manage Languages</h1>\n      <breadcrumbs [getDataFn]=\"breadcrumbsFN\"></breadcrumbs>\n      <synthrone-table #languageTable activeRouting=\"/languages\" [configColumns]=\"configColumns\" [getDataFromNewApiFn]=\"sdLangs\"></synthrone-table>\n    </div>\n  </div>\n</app-layout>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/languages-view/languages-view.component.html
// module id = ./src/app/components/views/languages-view/languages-view.component.html
// module chunks = main